module.exports = __webpack_public_path__ + "images/Adaptive_Biotech-bbbad3.png";